<template>
    <div class="category-title">
        <div
            v-html="icon"
            class="category-title__icon"
        ></div>
        <div class="category-title__caption">{{ category.title }}</div>
    </div>
</template>

<script>
    import icons from '@/configs/icons.js';

    export default {
        name: 'CategoryTitle',
        computed: {
            category () {
                return this.$store.getters.getCategory;
            },
            icon () {
                return icons.category[this.category.alias];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .category-title {
        &__icon {
            margin-top: 1em;
            text-align: center;
        }

        &__caption {
            font-size: 2em;
            text-align: center;
        }
    }
</style>